
<div>
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-note>Sale Reference ID</ion-note> 
        <br/>
        {{ sale.uuid }}
      </ion-col>
      <ion-col>
        <ion-note>Date</ion-note> 
        <br/>
        {{ sale.getDateTime() | salonMonsterDate: 'ddd, MMMM D, Y @ h:mm:ss a' }}
      </ion-col>
    </ion-row>
    <ion-row *ngIf="!isConfirmationPage">
      <ion-col>              
        <ion-note>Modified by</ion-note> 
        <br/>
        {{ sale.stylist.firstName }} {{ sale.stylist.lastName }}
      </ion-col>
      <ion-col>
        <ion-note>Modified Date</ion-note> 
        <br/>
        {{ sale.dateModified | salonMonsterDate: 'ddd, MMMM D, Y @ h:mm:ss a' }}
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-grid class="ion-no-padding ion-no-margin">
    <ion-row class="ion-margin-top">
      <ion-col>
        <smr-sale-client
          *ngFor="let client of sale.saleClients; trackBy: trackByTipID"  
          [client]="client"
          [sale]="sale"
          [readOnly]="true"
          >
        </smr-sale-client>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="sale.tips.count() > 0">
      <ion-col>
        <ion-list class="ion-no-padding ion-no-margin">
          <ion-list-header> 
            Tips
          </ion-list-header>
          <ion-item *ngFor="let tip of sale.tips; trackBy: trackByTipID" lines="none">
            {{ tip.stylist.firstName }} {{ tip.stylist.lastName ? tip.stylist.lastName.charAt(0) : '' }}<span slot="end">{{ tip.value | salonMonsterCurrency}}</span>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
    <hr/>
    <ion-row *ngIf="sale.payments.count() > 0" class="ion-no-padding ion-no-margin">
      <ion-col>
        <ion-list>
          <ion-list-header> 
            Payments
          </ion-list-header>
          <ion-item *ngFor="let payment of sale.payments; trackBy: trackByPaymentID" lines="none">
            {{ payment.name }}<ion-label slot="end">{{ payment.amount | salonMonsterCurrency}}</ion-label>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>

    <hr/>

    <ion-row>
      <ion-col>
        <ion-item lines="none">
          Subtotal<ion-label slot="end">{{ sale.subTotal | salonMonsterCurrency }}</ion-label>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row *ngFor="let tax of sale.taxes; trackBy: trackByTaxID">     
      <ion-col>
        <ion-item lines="none">
          {{ tax.name }}{{tax.bizNo !== undefined ? "#" : ""}}{{ tax.bizNo }}<ion-label slot="end">{{ tax.totals | salonMonsterCurrency }}</ion-label>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row *ngIf='sale.cashRounding !== 0'>
      <ion-col>
        <ion-item lines="none">
          Cash Rounding
          <ion-label slot="end">{{ sale.cashRounding | salonMonsterCurrency }}</ion-label>
        </ion-item>
       
      </ion-col>
    </ion-row>
    <hr/>
    <ion-row>
      <ion-col>
        <ion-item lines="none" class="total">
          TOTAL <ion-label slot="end">{{ sale.total | salonMonsterCurrency }}</ion-label>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
